module.exports = __webpack_public_path__ + "static/media/x-small-logo.5dc38413.svg";